module.exports = __webpack_public_path__ + "static/img/logo.e9e55214.png";